import React, { createContext, useReducer, useContext, useEffect } from 'react';
import { getShops, viewShop } from '../services/shopServices1';

// const Action = { type:  'LOGIN' | 'LOGOUT' , payload: any}
// export interface Dispatch { (action: Action) : void } 
// a context to hold states
const ShopStateContext = createContext()
// a context to hold dispatches
const ShopDispatchContext = createContext()

let shop;
const initialState = {
    isAuthenticated: false,
    isInitialized: false,
    shop: null,
};
const shopReducer = (state, action) => {
    switch (action.type) {
        // case 'addShop': {
        //     return [...state, {
        //       id: action.id,
        //       shop: action.payload,
        //     }];
        //   }
        // case 'LOGIN':
        //     localStorage.setItem('token', action.payload.token);
        //     return {
        //         ...state,
        //         user: action.payload
        //     }
        // case 'LOGOUT':
        //     localStorage.clear()
        //     return {
        //         ...state,
        //         user: null
        //     }
        default:
            throw new Error(`Unknown action ${action}`)
    }
}

export const ShopProvider = ({ children }) => {
    // viewShop({ id }).then((res)=> {
    //     localStorage.setItem('shop', JSON.stringify(res.data?.data.shop) )
    //     setgetViewShop(res.data?.data.shop)
    //     // navigate({pathname: PATH_MANAGEMENT.management.editShop}, {state: {mess: res.data?.data.shop }});
    //   })
    const shopId = localStorage.getItem('shopId')
    useEffect(() => {
        const initialize = async () => {
            try {
                if (shopId) {
                    console.log(shopId)
                    // setSession(accessToken);
                    const response = await viewShop(shopId).then((res)=> {console.log(res.data?.data)
                    // setUser(res.data?.data)
                    // dispatch({
                    //     type: 'INITIALIZE',
                    //     payload: {
                    //         // isAuthenticated: true,
                    //         shop: res.data?.data,
                    //     },
                    // });
                    })      
                } else {
                    // dispatch({
                    //     type: 'INITIALIZE',
                    //     payload: {
                    //         // isAuthenticated: false,
                    //         shop: null,
                    //     },
                    // });
                }
            } 
            catch (err) {
                console.error(err);
                // dispatch({
                //     type: 'INITIALIZE',
                //     payload: {
                //         // isAuthenticated: false,
                //         shop: null,
                //     },
                // });
            }
        };

        initialize();
    }, []);
    const [state, dispatch] = useReducer(shopReducer, { shop })
    const states = { state }
    const dispatches = { dispatch }
    const value = { dispatch, state }
    return (
        <ShopStateContext.Provider value={states}>
            <ShopDispatchContext.Provider value={dispatches}>
                {children}
            </ShopDispatchContext.Provider>
        </ShopStateContext.Provider>
    )
}


export const useShopState = () => useContext(ShopStateContext)
export const useShopDispatch = () => useContext(ShopDispatchContext)
